var array = Array.prototype;

export var slice = array.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-contour/src/array.js
// module id = U3yV
// module chunks = 0